export function formatFileSize(size: number | undefined | null): string {
  if (size == null || Number.isNaN(Number(size)) || size < 0) {
    return "—";
  }
  const units = ["Bytes", "KB", "MB", "GB", "TB"];
  let n = Number(size);
  let index = 0;

  while (n >= 1024 && index < units.length - 1) {
    n /= 1024;
    index++;
  }

  return `${n.toFixed(2)} ${units[index]}`;
}